// Framework and third-party non-UI
import React, { useContext } from 'react';

// Redux, contexts, and local helpers/utils/modules
import { DataGridContext } from './DataGrid';

// Component specific modules (Component-styled, etc.)
import { StyledDataGridBody } from './DataGrid-styled';

// App components

// Third-party components (buttons, icons, etc.)

const DataGridBody: React.FC = ({ children }) => {
  const dataGridContext = useContext(DataGridContext);
  return (
    <StyledDataGridBody {...dataGridContext}>{children}</StyledDataGridBody>
  );
};

export default DataGridBody;
